import Hero from './views/Hero';
export default Hero;
